// extracted by mini-css-extract-plugin
module.exports = {"check":"InputCheck_check__3-Lp_"};